import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { StorageKeys } from '../app.constants';
import { ProchainsCreneaux } from '../entities/creneaux/prochains-creneau.model';
import { LoggingService } from '../shared/logging.service';
import { AbstractReadService } from './abstract.read.service';
import { OfflineNotificationService } from './offline-notification.service';
import { ServerUrl } from './server-url.service';
import { StorageService } from './storage.service';
import { UserEventWriteService } from './user-event.write.service';

@Injectable({ providedIn: 'root' })
export class ProchainsCreneauxReadService extends AbstractReadService<ProchainsCreneaux> {
  private readonly prefix: string = '/me/creneaux';

  constructor(
    http: HttpClient,
    storage: StorageService,
    offlineService: OfflineNotificationService,
    userEventWriteService: UserEventWriteService,
    private readonly serverUrl: ServerUrl,
    log: LoggingService
  ) {
    super(http, storage, offlineService, userEventWriteService, log);
  }

  public hydrate(obj: any): ProchainsCreneaux {
    const prochain = obj ? ProchainsCreneaux.hydrate(obj) : new ProchainsCreneaux();
    // TODO: fix photo manquante enregistrement failed
    return prochain;
  }

  public getStorageKey(): string {
    return StorageKeys.PROCHAIN_CRENEAU_GARDIENNAGE;
  }

  public getResourceURL(param: any = null): string {
    return this.serverUrl.get() + this.prefix + '/prochain';
  }
}
